import { type ActionEvent, Controller } from "@hotwired/stimulus"

import DrawerController from "../drawer_controller"

import CounterController from "@/controllers/counter_controller"
import { pluralize } from "@/helpers/pluralize"

const LARGE_GROUP_THRESHOLD = 8

export default class extends Controller {
  static outlets = ["drawer", "guests-counter"]
  declare readonly drawerOutlet: DrawerController
  declare readonly hasDrawerOutlet: boolean
  declare readonly guestsCounterOutlet: CounterController

  static targets = ["guestsInput", "guestsSummary", "groupsLink"]
  declare readonly guestsInputTarget: HTMLInputElement
  declare readonly guestsSummaryTarget: HTMLElement
  declare readonly groupsLinkTarget: HTMLAnchorElement

  get isZeroSelected(): boolean {
    return this.guestsCounterOutlet.countValue === 0
  }

  openGuestsDrawer(): void {
    this.drawerOutlet.open()
  }

  resetGuests(): void {
    this.guestsCounterOutlet.setCountTo(0)
  }

  resetIfEmpty({ currentTarget }: ActionEvent): void {
    if (!(currentTarget as HTMLInputElement).value) {
      this.resetGuests()
    }
  }

  setGuestsSummary(): void {
    const summaryText = this.isZeroSelected
      ? "Any"
      : pluralize(this.guestsCounterOutlet.countValue, "person", "people")

    if (this.isModal) {
      this.guestsSummaryTarget.textContent = summaryText
    } else {
      this.guestsInputTarget.value = summaryText
    }
  }

  onCountChange(): void {
    const { countInputTarget, countValue } = this.guestsCounterOutlet

    // Disable guests counter input if zero so it's not submitted.
    countInputTarget.disabled = countValue === 0
    this.groupsLinkTarget.hidden = countValue < LARGE_GROUP_THRESHOLD

    this.setGuestsSummary()
  }

  private get isModal(): boolean {
    return this.hasDrawerOutlet
  }
}
